import React from 'react'
import SuccessScreen from '../Common/SuccessScreen'
import { useNavigate } from 'react-router-dom';

const CompletePO = () => {
    const navigate = useNavigate();
    const filledButtonAction = () => {
        navigate('/po-list');
    }
    const OutlinedButtonAction = () => {
        navigate('/my-business');
    }
    return (
        <SuccessScreen
            title="Successful!"
            subtitle="Your Purchase Order has been created."
            filledButtonLabel="View Purchase Orders"
            filledButtonAction={filledButtonAction}
            OutlinedButtonLabel="My Business"
            OutlinedButtonAction={OutlinedButtonAction}
        />
    )
}

export default CompletePO